import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';

import UrejanjeObrazcaStranka from './components/portal/Obrazci/UrejanjeObrazcaStranka';
import DomovStranka from './components/portal/Stranka/DomovStranka';
import ObrazciStranka from './components/portal/Stranka/ObrazciStranka';
import DomovAdmin from './components/portal/Admin/DomovAdmin';
import ObrazciAdmin from './components/portal/Admin/ObrazciAdmin';
import CertifikatiStranka from './components/portal/Stranka/CertifikatiStranka';
import PrijavaStranka from './components/portal/Stranka/PrijavaStranka';

const AppRoutes = [
    {
        index: true,
        requireAuth: true,
        element: <DomovStranka />
    },
    {
        path: '/domov',
        requireAuth: true,
        element: <DomovStranka />
    },
    {
        path: '/domovAdmin',
        requireAuth: true,
        element: <DomovAdmin />
    },
    {
        path: '/obrazciStranka',
        requireAuth: true,
        element: <ObrazciStranka />
    },
    {
        path: '/certifikatiStranka',
        requireAuth: true,
        element: <CertifikatiStranka />
    },
    {
        path: '/obrazciAdmin',
        requireAuth: true,
        element: <ObrazciAdmin />
    },
    {
        path: '/UrejanjeObrazcaStranka',
        requireAuth: true,
        element: <UrejanjeObrazcaStranka />
    },
    {
        path: '/Prijava',
        requireAuth: false,
        element: <PrijavaStranka />
    },
    ...ApiAuthorzationRoutes
];

export default AppRoutes;
